import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

const baseUrl = "statistic";

export async function getAttendanceLeaveStatistic({
  companyId,
  page,
  limit,
  selectedFilter,
}) {
  try {
    const params = new URLSearchParams(url.search);
    params.append("page", page || 1);
    params.append("limit", limit || 5);
    params.append("company_id", companyId);
    if (selectedFilter === "by_late") {
      params.append("by_late", true);
    } else if (selectedFilter === "by_absent") {
      params.append("by_absent", true);
    } else if (selectedFilter === "off_day") {
      params.append("off_day", true);
    } else if (selectedFilter === "leave_request") {
      params.append("leave_request", true);
    } else if (selectedFilter === "leave_today") {
      params.append("leave_today", true);
    }
    const { data } = await axios.get(
      `${URL_API}/${baseUrl}/attendance-and-leave?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );

    return {
      success: true,
      message: "",
      data: data.data,
      meta: data.meta,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}
